import { render, staticRenderFns } from "./CustomersListSection.vue?vue&type=template&id=31e23031&scoped=true"
import script from "./CustomersListSection.vue?vue&type=script&lang=js"
export * from "./CustomersListSection.vue?vue&type=script&lang=js"
import style0 from "./CustomersListSection.vue?vue&type=style&index=0&id=31e23031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e23031",
  null
  
)

export default component.exports